module.exports = __webpack_public_path__ + "static/media/schedule.7859d42e.svg";